export default function getResource(label, vars = []) {
    const resources = {
        title: 'De la foire aux récompenses Rewards Bazaar',
        titleRouge: 'More Great Rewards',
        viewAll: 'Tout afficher',
        add: 'Ajouter',
        rougeBadge: 'ROUGE EXCLUSIVE'
    };
    return resources[label];
}
